import { render, staticRenderFns } from "./Umbrella.vue?vue&type=template&id=95d821a4&scoped=true&"
import script from "./Umbrella.vue?vue&type=script&lang=ts&"
export * from "./Umbrella.vue?vue&type=script&lang=ts&"
import style0 from "./Umbrella.vue?vue&type=style&index=0&id=95d821a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d821a4",
  null
  
)

export default component.exports